import componentStyles from './landing.module.css';
import globalStyles from '../globals.module.css';
import { FaChartLine, FaBell, FaRobot, FaSearch } from 'react-icons/fa';
import eventBus from '../../service/eventBus';
import { EVENT_UPDATE_ACTION_BAR_VIEW } from '../../utils/constants';
import PageView from '../common/pageView';

const Landing = () => {

    const handleLogin = () => {
        eventBus.emit(EVENT_UPDATE_ACTION_BAR_VIEW, 'login');
    }

    const handleRegister = () => {
        eventBus.emit(EVENT_UPDATE_ACTION_BAR_VIEW, 'register');
    }

    return (
        <PageView title="Sports Intelligence Terminal" contentClassName={componentStyles.landingContainer}>
            {/* Hero Section */}
            <section className={componentStyles.heroSection}>
                <h1>Smart Sports Betting Analytics</h1>
                <p className={componentStyles.heroSubtitle}>
                    Make informed betting decisions with AI-powered insights and real-time analytics
                </p>
                <div className={componentStyles.loginBtnGroup}>
                    <button className={globalStyles.primaryButton} onClick={handleLogin}>Login</button>
                    <button className={globalStyles.secondaryButton} onClick={handleRegister}>Register</button>
                </div>
                {/* <div className={componentStyles.waitlistForm}>
                    <form onSubmit={handleWaitlistSubmit}>
                        <input
                            type="email"
                            placeholder="Enter your email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                        />
                        <button 
                            type="submit" 
                            className={globalStyles.primaryButton}
                            disabled={isSubmitting}
                        >
                            {isSubmitting ? 'Joining...' : 'Join Waitlist'}
                        </button>
                    </form>
                    {status === 'success' && (
                        <p className={componentStyles.successMessage}>
                            Thanks for joining! We'll be in touch soon.
                        </p>
                    )}
                    {status === 'error' && (
                        <p className={componentStyles.errorMessage}>
                            Something went wrong. Please try again.
                        </p>
                    )}
                </div> */}
            </section>

            {/* Features Section */}
            <section className={`${globalStyles.standardSection} ${componentStyles.featuresSection}`}>
                <h2 className={globalStyles.sectionHeader}>Platform Functions</h2>
                <div className={componentStyles.featuresGrid}>
                    <div className={componentStyles.featureCard}>
                        <FaChartLine className={componentStyles.featureIcon} />
                        <h3>Advanced Analytics</h3>
                        <p>Deep statistical analysis of player and team performance metrics</p>
                    </div>
                    <div className={componentStyles.featureCard}>
                        <FaBell className={componentStyles.featureIcon} />
                        <h3>Real-time Alerts</h3>
                        <p>Instant notifications for betting opportunities and line movements</p>
                    </div>
                    <div className={componentStyles.featureCard}>
                        <FaRobot className={componentStyles.featureIcon} />
                        <h3>AI Predictions</h3>
                        <p>Machine learning models trained on historical data for accurate predictions</p>
                    </div>
                    <div className={componentStyles.featureCard}>
                        <FaSearch className={componentStyles.featureIcon} />
                        <h3>Custom Research</h3>
                        <p>Personalized betting insights based on your preferences</p>
                    </div>
                </div>
            </section>

            {/* Pricing Section */}
            <section className={`${globalStyles.standardSection} ${componentStyles.pricingSection}`}>
                <h2 className={globalStyles.sectionHeader}>Access Tiers</h2>
                <div className={componentStyles.pricingGrid}>
                    <div className={componentStyles.pricingCard}>
                        <h3>Free</h3>
                        <p className={componentStyles.price}>$0/month</p>
                        <ul>
                            <li>Basic bet tracking</li>
                            <li>Limited feed access</li>
                            <li>Basic statistics</li>
                        </ul>
                    </div>
                    <div className={`${componentStyles.pricingCard} ${componentStyles.popularPlan}`}>
                        <div className={componentStyles.popularBadge}>Most Popular</div>
                        <h3>Plus</h3>
                        <p className={componentStyles.price}>$9.99/month</p>
                        <ul>
                            <li>Advanced bet tracking</li>
                            <li>Full feed access</li>
                            <li>Advanced statistics</li>
                            <li>Email notifications</li>
                        </ul>
                    </div>
                    <div className={componentStyles.pricingCard}>
                        <h3>Pro</h3>
                        <p className={componentStyles.price}>$19.99/month</p>
                        <ul>
                            <li>Premium bet tracking</li>
                            <li>Real-time updates</li>
                            <li>Advanced analytics</li>
                            <li>Priority support</li>
                            <li>Custom alerts</li>
                        </ul>
                    </div>
                </div>
            </section>

            {/* FAQ Section */}
            <section className={`${globalStyles.standardSection} ${componentStyles.faqSection}`}>
                <h2 className={globalStyles.sectionHeader}>Terminal Notes</h2>
                <div className={componentStyles.faqGrid}>
                    <div className={componentStyles.faqItem}>
                        <h3>How accurate are the predictions?</h3>
                        <p>Our AI models are continuously trained on the latest data, achieving high accuracy rates in historical testing.</p>
                    </div>
                    <div className={componentStyles.faqItem}>
                        <h3>What sports do you cover?</h3>
                        <p>We currently cover NBA, NFL, MLB, NHL, MMA, and Soccer, with more sports coming soon.</p>
                    </div>
                    <div className={componentStyles.faqItem}>
                        <h3>Can I cancel my subscription?</h3>
                        <p>Yes, you can cancel your subscription at any time with no questions asked.</p>
                    </div>
                    <div className={componentStyles.faqItem}>
                        <h3>How do I get started?</h3>
                        <p>Join our waitlist to be notified when we launch and get early access to our platform.</p>
                    </div>
                </div>
            </section>
        </PageView>
    );
};

export default Landing;
